<template>
  <div class="party-money">
    <div class="party-name">
      <p>党员名称</p>
      <p>{{name}}</p>
    </div>
    <div class="party-branch">
      <p>党支部</p>
      <p>{{partyBranch}}</p>
    </div>
    <div class="pay-the-fees">
      <p>每月缴纳价额（元）</p>
      <p>{{unit}}元</p>
    </div>
    <div class="deadline">
      <p>选择缴纳期限</p>
      <el-date-picker
        v-model="deadline"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="yyyy 年 MM 月"
      ></el-date-picker>
    </div>

    <div class="pay-ways">
      <p class="title">选择支付方式</p>
      <div class="pay-template">
        <img src="@/assets/partyhome/partyManage/dp-dy-df3.png" alt />
        <span>支付宝支付</span>
        <el-radio v-model="radio" label="1">{{money}}</el-radio>
      </div>
      <div class="pay-template">
        <img src="@/assets/partyhome/partyManage/dp-dy-df4.png" alt />
        <span>微信支付</span>
        <el-radio v-model="radio" label="2">{{money}}</el-radio>
      </div>

      <div class="all-money">共计4个月 总金额:￥56</div>
    </div>

    <div class="submit">
      <button @click="submit">确认提交</button>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      name: sessionStorage.getItem("name"),
      partyBranch: sessionStorage.getItem("partybrach"),
      deadline: "",
      radio: "1",
      unit: 26,
      money: '0元'
    };
  },
  name: "partyMoney",
  props: {},
  methods: {
    submit() {
      console.log(this.deadline);
    }
  },
  watch: {
    deadline: function(month) {
      let money = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ];
     let month1 = month[0].getMonth() + 1;
     let month2 = month[1].getMonth() + 1;
      this.money = (month2 - month1) * this.unit + '元';
    }
  }
};
</script>


<style lang="scss" scoped>
.party-money {
  .submit {
    button {
      color: #f6f5f8;
      background-image: linear-gradient(-70deg, #f9b94d 0%, #fdcb76 100%);
      border-radius: 0.08rem;
      padding: 0.2rem 0.4rem;
      border: 0;
    }
    text-align: center;
    padding: 0.3rem 0;
    border-top: 0.3rem solid #f9f9f9;
  }
  .pay-ways {
    .all-money {
      text-align: right;
      color: #ffa000;
      padding-right: 0.2rem;
      line-height: 3;
    }
    .title {
      line-height: 3;
      padding-left: 0.2rem;
    }
    .pay-template {
      .el-radio {
        margin-left: auto;
      }
      img {
        width: 0.35rem;
        height: 0.35rem;
        margin-right: 0.2rem;
      }
      display: flex;
      align-items: center;
      padding: 0.2rem;
      border-bottom: 0.01rem solid #eeeeee;
    }
    border-top: 0.3rem solid #f9f9f9;
  }
  .deadline {
    p {
      line-height: 3;
    }
    padding: 0.2rem;
  }
  .pay-the-fees,
  .party-branch,
  .party-name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem;
    border-bottom: 0.01rem solid #e6e6e6;
  }
  background: #fff;
}


</style>

<style lang="scss" >
.party-money{
  .deadline{
    .el-date-editor--monthrange.el-input, .el-date-editor--monthrange.el-input__inner {
      span{
        width: auto
      }
      input{
        width: 35%;
      }
      width: 100%;
    }
  }
}
</style>
